export const MAX_MOBILE_WIDTH = 751
export const MAX_TABLET_WIDTH = 1023
export const MAX_DESKTOP_WIDTH = 1439
export const MAX_WIDTH_FOR_MOBILE_ASSETS = 480
export const MIN_NO_OF_USES = 500
export const MAX_TAG_ON_MOBILE = 1
export const MAX_TAG_ON_TABLET = 3
export const MIN_AVG_SAVED = 10
export const MAX_LAST_USED_HOURS = 24
export const MAX_EXPIRY_HOURS = 72

export const COUPON_TYPE = 'coupon'
export const REVEALED_COUPON_TYPE = 'revealed_coupon'
export const SALE_TYPE = 'sale'
export const DEFAULT_MERCHANT_LOGO =
  'https://www.paypalobjects.com/muse/img/honey/honey-default-card-logo.png'
export const DEFAULT_MERCHANT_BACKGROUND = '#0070ba'
// shopping Merchant Store SEO instrumentation variables
export const IMPRESSION = 'im'
export const CLICK = 'cl'
// event_name
export const SHOPPING_MERCHANT_SCREEN_SHOWN = 'shopping_merchant_screen_shown'
export const SHOPPING_MERCHANT_SITE_PRESSED = 'shopping_merchant_site_pressed'
export const SHOPPING_MERCHANT_TAB_ALL_PRESSED =
  'shopping_merchant_tab_all_pressed'
export const SHOPPING_MERCHANT_TAB_CODES_PRESSED =
  'shopping_merchant_tab_codes_pressed'
export const SHOPPING_MERCHANT_TAB_DEALS_PRESSED =
  'shopping_merchant_tab_deals_pressed'
export const SHOPPING_MERCHANT_DEAL_PRESSED = 'shopping_merchant_deal_pressed'
export const SHOPPING_MERCHANT_CODE_PRESSED = 'shopping_merchant_code_pressed'
export const SHOPPING_MERCHANT_CODE_SCREEN_SHOWN =
  'shopping_merchant_code_screen_shown'
export const SHOPPING_MERCHANT_CODE_COPY_PRESSED =
  'shopping_merchant_code_copy_pressed'
export const SHOPPING_MERCHANT_CODE_USE_PRESSED =
  'shopping_merchant_code_use_pressed'
export const SHOPPING_MERCHANT_DEAL_USE_PRESSED =
  'shopping_merchant_deal_use_pressed'
export const SHOPPING_MERCHANT_CODE_CLOSE_PRESSED =
  'shopping_merchant_code_close_pressed'
export const ICON_NUMBER_OF_USES =
  'https://www.paypalobjects.com/shopping/icons/label-number-of-uses.svg'
export const ICON_CLOCK =
  'https://www.paypalobjects.com/shopping/icons//label-clock.svg'
export const ICON_TAG =
  'https://www.paypalobjects.com/shopping/icons/label-tag.svg'
export const ICON_SAVINGS =
  'https://www.paypalobjects.com/shopping/icons/label-savings.svg'
export const ICON_FEEDBACK =
  'https://www.paypalobjects.com/shopping/icons/feedback.svg'
export const ICON_INSTORE =
  'https://www.paypalobjects.com/shopping/icons/label-instore.svg'

export const ICON_CHECKMARK =
  'https://www.paypalobjects.com/shopping/icons/label-checkmark.svg'

export const ICON_CHECK_CIRCLE =
  'https://www.paypalobjects.com/shopping/icons/check-circle.svg'

export const ICON_WALLET =
  'https://www.paypalobjects.com/shopping/icons/wallet.svg'

export const WALLET_OFFER_URL = '/myaccount/money/flow/offers/'
export const WALLET_OFFER_REDIRECT_FLOW_QUERY_PARAM =
  '?flow=eyJyZXR1cm5VcmwiOiIvc2hvcHBpbmciLCJjYW5jZWxVcmwiOiIvc2hvcHBpbmcifQ=='

export const OFFER_DETAIL_SCREEN_SHOWN = 'shopping_offer_detail_screen_shown'
export const OFFER_DETAIL_CTA_CLICKED = 'shopping_offer_detail_cta_pressed'
export const OFFER_DETAIL_DISMISS_CLICKED =
  'shopping_offer_detail_dismiss_pressed'

export const LOGGING_HEADER_MOBILE_BREAKPOINT = 768
